import { Icon } from '@components/atoms'
import { css, styled } from '@styles/theme'

export const RankingStyles = {
	container: css({
		background: '$neutral30',
		padding: '24px',
		width: '100%',

		'@sm': {
			padding: '8px 65px 8px 61px',
		},
	}),
	containerTitle: css({
		display: 'flex',
		flexDirection: 'column',
		marginBottom: '24px',
		gap: '16px',
		'@sm': {
			marginTop: '40px',
			marginBottom: '33px',
		},
		'@lg': {
			flexDirection: 'row',
			justifyContent: 'space-between',
		},
	}),
	title: css({
		display: 'flex',
		justifyContent: 'space-between',
		flexDirection: 'column',
		'@md': {
			flexDirection: 'row',
		},
	}),
	boxSelects: css({
		display: 'flex',
		flexDirection: 'column',
		gap: '23px',
		width: '100%',
		maxWidth: '400px',
		alignItems: 'center',

		'@md': {
			width: '100%',
			maxWidth: '500px',
			flexDirection: 'row',
			display: 'flex',
			gap: '28px',
			marginTop: '0px',
		},
	}),
	boxSelect: css({
		display: 'flex',
		flexDirection: 'row',
		width: '100%',
		maxWidth: '500px',

		'@md': {
			width: '100%',
			flexDirection: 'row',
			display: 'flex',
			gap: '28px',
			marginTop: '0px',
		},
	}),
	table: css({
		width: '100%',
		display: 'flex',
		flexWrap: 'wrap',
		marginBottom: 32,
	}),
	itemImageNew: css({
		borderRadius: '50%',
		width: '28px',
		height: '28px',
	}),
}

export const AvatarDefault = styled('div', {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '28px',
	height: '28px',
	position: 'relative',
	backgroundColor: '$blue20',
	borderRadius: '26px',

	'p.charAtName': {
		_font: 'bold',
		fontWeight: '700',
		fontSize: '12px',
		letterSpacing: '0.6px',
		color: '$neutral10',
	},
})

export const Rank = styled('div', {
	margin: 'auto',
	width: '100%',
	maxWidth: '90%',
	display: 'flex',
	alignItems: 'end',
	justifyContent: 'center',
	gap: '10%',

	'@sm': {
		gap: 42,
	},
})

export const Podium = styled('div', {
	width: '100%',
	maxWidth: 76,
	display: 'flex',
	flexDirection: 'column',
})

export const Position = styled('div', {
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	gap: 4,
	padding: '1px 13px 4px',

	'& p': {
		fontSize: '$p',
		fontFamily: 'Roboto',
		fontStyle: '$normal',
		fontWeight: '$normal',
		letterSpacing: '0.05em',

		color: '$neutral160',

		'@lg': {
			fontSize: '$lg',
			letterSpacing: '0.8px',
		},
	},
})

export const Bench = styled('div', {
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	borderTopLeftRadius: 12,
	borderTopRightRadius: 12,
	gap: 12,
	background: 'linear-gradient(180deg, #9FE1FD 0%, #F6F6F6 100%)',
	'& p': {
		fontSize: '16px',
		fontFamily: 'Roboto',
		fontStyle: '$normal',
		fontWeight: '$bold',
		color: '$blue20',
	},

	variants: {
		position: {
			none: {
				height: 0,
			},
			first: {
				height: 103,
				svg: {
					marginBottom: '50%',
				},
				'@sm': {
					height: 138,
					svg: {
						marginBottom: '80%',
					},
				},
			},
			second: {
				height: 79,

				svg: {
					marginBottom: '20%',
				},

				'@sm': {
					height: 114,
					svg: {
						marginBottom: '50%',
					},
				},
			},
			third: {
				height: 46,

				svg: {
					width: '32px',
					height: '32px',
					marginBottom: '5%',
				},

				'@sm': {
					height: 81,

					svg: {
						marginBottom: '30%',
					},
				},
			},
		},
	},
})

export const BenchIcon = styled(Icon, {})

export const ItemTable = styled('div', {
	width: '100%',
	background: '$neutral10',
	padding: '16px',
	display: 'grid',
	gridTemplateColumns: '1fr 1fr 5.5fr 0.5fr',
	gridTemplateRows: '1fr',
	gap: '0px 0px',
	gridAutoFlow: 'row',
	gridTemplateAreas: '. . . .',
	alignItems: 'center',
	boxShadow: '0px 0px 3px 0px rgba(0, 0, 0, 0.13)',

	'&:first-child': {
		borderTopLeftRadius: 12,
		borderTopRightRadius: 12,
	},

	'&:last-child': {
		borderBottomLeftRadius: 12,
		borderBottomRightRadius: 12,
		borderBottom: 'none',
	},

	'@md': {
		padding: '20px 32px',
		gridTemplateColumns: '1fr 1fr 7.5fr 0.5fr',
	},

	'@xl': {
		gridTemplateColumns: '1fr 1fr 8.5fr 0.5fr',
	},

	'@2xl': {
		gridTemplateColumns: '1fr 0.5fr 10.5fr 0.5fr',
	},

	variants: {
		myRank: {
			true: {},
		},
	},
})

export const ItemRank = styled('span', {
	display: 'flex',
	fontFamily: 'Roboto',
	fontStyle: '$normal',
	fontWeight: '$bold',
	fontSize: '$p',
	lineHeight: '21px',
	letterSpacing: ' 0.04em',
	color: '$blue20',
	position: 'relative',

	'@md': {
		fontSize: '$lg',
		lineHeight: 'normal',
	},
})

export const ItemImage = styled('img', {
	borderRadius: '50%',
	width: '28px',
	height: '28px',
})

export const ImageIcon = styled(Icon, {
	borderRadius: '50%',
	position: 'relative',
	left: '-10px',
})

export const ItemName = styled('p', {
	_font: 'normal',
	fontWeight: '400',
	fontSize: '$md',
	lineHeight: '20px',
	letterSpacing: ' 0.05em',
	color: '$neutral160',

	'@sm': {
		fontWeight: '$bold',
		fontSize: '$xl',
		lineHeight: '18px',
		letterSpacing: ' 0.04em',
	},
})

export const ItemPoints = styled('p', {
	_font: 'normal',
	fontWeight: '700',
	fontSize: '$p',
	lineHeight: '21px',
	letterSpacing: ' 0.05em',
	textAlign: 'end',
	color: '$blue20',

	'@sm': {
		_font: 'normal',
		fontWeight: '$bold',
		fontSize: '$xl',
		lineHeight: '18px',
		letterSpacing: ' 0.04em',
	},
})
